export enum EbayProductFieldType {
  Title = "title",
  Description = "description",
  Condition = "condition",
  Price = "price",
  Brand = "brand",
  Category = "category",
  Aspect = "aspect",
}
